'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CarHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Header = require('./Header.scss');

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarHeader(props) {
  var text = props.text;
  var components = props.components;


  return _react2.default.createElement(
    'div',
    { className: _Header2.default.root },
    'Rules Configuration'
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/Header/Header.jsx
// module id = 1461
// module chunks = 0